import React, { useEffect, useState } from 'react'
import { Form, FormInstance, Input } from 'antd'
import Subform from './Subform'
import { HiddenInputs } from './styledComponents'

interface RecipientSubformProps {
  form: FormInstance
}

const RecipientSubform = ({ form }: RecipientSubformProps) => {
  const { first_name, last_name, contact_num } = form.getFieldsValue()
  const [displayName, setDisplayName] = useState<string>(
    `${first_name} ${last_name} (${contact_num})`
  )

  useEffect(() => {
    setDisplayName(`${first_name} ${last_name} (${contact_num})`)
  }, [first_name, last_name, contact_num])

  const handleSave = () => {
    const {
      customer_detais_subform: { first_name, last_name, contact_num }
    } = form.getFieldsValue()

    form.setFieldsValue({ first_name, last_name, contact_num })
    setDisplayName(`${first_name} ${last_name} (${contact_num})`)
  }

  const handleCancel = () => {
    form.setFieldsValue({
      customer_detais_subform: { first_name, last_name, contact_num }
    })
  }

  return (
    <>
      <Subform
        onCancel={handleCancel}
        onSave={handleSave}
        label='Recipient:'
        value={displayName}
      >
        <Form.Item
          rules={[
            { required: true, message: 'Please select at least one category' }
          ]}
          validateTrigger='onBlur'
          name={['customer_detais_subform', 'first_name']}
          label='First name'
        >
          <Input />
        </Form.Item>
        <Form.Item
          rules={[
            { required: true, message: 'Please select at least one category' }
          ]}
          validateTrigger='onBlur'
          name={['customer_detais_subform', 'last_name']}
          label='Last name'
        >
          <Input />
        </Form.Item>
        <Form.Item
          rules={[
            { required: true, message: 'Please select at least one category' }
          ]}
          validateTrigger='onBlur'
          name={['customer_detais_subform', 'contact_num']}
          label='Contact number'
        >
          <Input prefix='+44' />
        </Form.Item>
      </Subform>
      <HiddenInputs>
        <Form.Item name='customer_detais_subform' />
        <Form.Item name='first_name' />
        <Form.Item name='last_name' />
        <Form.Item name='contact_num' />
      </HiddenInputs>
    </>
  )
}

export default RecipientSubform
